<template>
    <div>
        <v-card>
            <v-card-title>Hint {{data.hintNo}}</v-card-title>
            <v-card-text v-html="data.hintText">
            <!-- <v-card-text v-html="data.hintText.replace(/<[^>]+>/g, '')">   removed the replace function to correctly display the images in hint as well-->
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "Hint",
    props: ["data", "onClose"],
    data: function() {
        return {}
    },
    methods: {
        ...mapActions({
            objectQuestion: "resultStore/objectQuestion"
        }),
    },
    mounted() {
        this.renderMath();
    },
    watch: {
        "data.hintText": function (val) {
            this.renderMath();
        },
    },
};
</script>